module.exports = __webpack_public_path__ + "static/media/PFDinTextPro-Bold.9ff66ae8.woff";